import React from 'react';
import { PasswordGeneratorObserver } from './observers/password-generator-observer';
import './app.scss';

export const App: React.FC = () => {
  return (
    <div className="app">
      <PasswordGeneratorObserver />
    </div>
  );
};
